import { render, staticRenderFns } from "./InitialInfoModal.vue?vue&type=template&id=9b929af4"
import script from "./InitialInfoModal.vue?vue&type=script&lang=js"
export * from "./InitialInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports